import { PopupList } from '../../atoms/PopupList';
import React, { FC } from 'react';
import { Button, ButtonSize, ButtonStyle } from '../../atoms/Button';
import { StyledActionButton } from './ButtonList.styles';
import { prop } from 'ramda';

type ButtonItem = {
  label: string;
  enabled: boolean;
  value: string;
};
interface ButtonListProps {
  buttonItems: ButtonItem[];
  description: string;
  handleClick: (value: string) => void;
}
export const ButtonList: FC<ButtonListProps> = ({
  buttonItems,
  description,
  handleClick,
}) => {
  return (
    <PopupList
      items={(closePopup) => (
        <>
          {!buttonItems.some(prop('enabled')) && (
            <p style={{ maxWidth: '13rem', marginBottom: 0 }}>
              <em>No bulk actions are possible with the currenct selection</em>
            </p>
          )}
          {buttonItems.map((item) =>
            item.enabled ? (
              <StyledActionButton
                $buttonStyle={ButtonStyle.Secondary}
                $buttonSize={ButtonSize.Small}
                disabled={!item.enabled}
                onClick={() => {
                  handleClick(item.value);
                  closePopup();
                }}
              >
                {item.label}
              </StyledActionButton>
            ) : null,
          )}
        </>
      )}
      popupDescription={description}
    >
      <Button $buttonStyle={ButtonStyle.Secondary}>{description}</Button>
    </PopupList>
  );
};
